import { DoCheck, Injectable, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { ValidationServiceLabelEN } from 'src/app/models/labels/validationServiceLabel_EN';
import { ValidationServiceLabelHN } from 'src/app/models/labels/validationServiceLabel_HN';
import { BorrowerRenderingService } from '../borrower/borrower-rendering.service';

@Injectable({
  providedIn: 'root'
})

export class ValidationService{

  label : any;

  constructor(private borrowerRenderingService:BorrowerRenderingService) { }

  // return list of error messages
  public validationMessages(controlName) {

    if(this.borrowerRenderingService.language){
      if(this.borrowerRenderingService.language==="ENGLISH"){
        this.label = new ValidationServiceLabelEN();
      }else if(this.borrowerRenderingService.language==="HINDI"){
        this.label = new ValidationServiceLabelHN();
      }
    }else{
        this.label = new ValidationServiceLabelEN();
    }

    const messages = {
      required: this.label.validation.required,
      maxlength: this.getMaxLengthErrorMessage(controlName),
      minlength: this.getMinLengthErrorMessage(controlName),
      max: this.getMaxValueMessage(controlName),
      min: this.getMinValueMessage(controlName),
      pattern: this.getPatternErrorMessage(controlName),
      confirmEmailValidation: this.label.validation.confirmEmailValidation,
      confirmPANValidation: this.label.validation.confirmPANValidation,
      confirmTINValidation: this.label.validation.confirmTINValidation,
      tinValidation: this.label.validation.tinValidation,
      salaryValidation: this.label.validation.salaryValidation,
      confirmMobileValidation: this.label.validation.confirmMobileValidation,
      nameValidation: this.label.validation.nameValidation,
      midNameValidation: this.label.validation.midNameValidation,
      dateValidation: this.label.validation.dateValidation,
      toDateValidation: this.label.validation.toDateValidation,
      aadharValidation: this.label.validation.aadharValidation,
      itrIncomeValidation: this.label.validation.itrIncomeValidation,
      downpaymentMaxValidation: this.label.validation.downpaymentMaxValidation,
      downpaymentMinValidation: this.label.validation.downpaymentMinValidation,
    };
    return messages;
  }


  getMaxLengthErrorMessage(controlName) {

    if(this.borrowerRenderingService.language){
      if(this.borrowerRenderingService.language==="ENGLISH"){
        this.label = new ValidationServiceLabelEN();
      }else if(this.borrowerRenderingService.language==="HINDI"){
        this.label = new ValidationServiceLabelHN();
      }
    }else{
        this.label = new ValidationServiceLabelEN();
    }

    if (controlName == 'primaryMobilePhone' || controlName == 'otherMobilePhone' || controlName == 'mobilePhone1' || controlName == 'mobilePhone2') {
      return this.label.validation.tenDigitPhoneValidation; 
      // return 'Please enter 10 digit phone number.';
    }
    else if (controlName == 'firstName' || controlName == 'middleName' || controlName == 'contactPerson' || controlName == 'referenceName1' || controlName == 'referenceName2') {
      return this.label.validation.thirtyCharExceedNameValidation;
      // return "Name should not exceed 30 characters."
    }
    else if (controlName == 'spouseName' || controlName == 'motherName') {
      return this.label.validation.sixtyCharExceedNameValidation;
      // return "Name should not exceed 60 characters."
    }
    else if (controlName == 'lastName') {
      return this.label.validation.twentyCharExceedLastNameValidation;
      // return "Last name should not exceed 20 characters."
    }
    else if (controlName == 'aadhar') {
      return this.label.validation.tweleveDigitAdharValidation;
      // return "Please enter 12 digit Aadhar number"
    }
    else if (controlName == 'currentBuildingNo' || controlName == 'currentStreetName' || controlName == 'permanentBuildingNo' || controlName == 'permanentStreetName') {
      return this.label.validation.fortyCharExceedAddressValidation;
      // return "Address should not exceed 40 characters."
    }
    else if (controlName == 'currentArea' || controlName == 'permanentArea') {
      return this.label.validation.fiftyCharExceedAreaValidation;
      // return "Area should not exceed 50 characters."
    }
    else if (controlName == 'currentCity' || controlName == 'permanentCity') {
      return this.label.validation.twentyFiveCharExceedCityValidation;
      // return "City should not exceed 25 characters."
    }
    else if (controlName == 'currentPinCode' || controlName == 'permanentPinCode') {
      return this.label.validation.sixDigitPinCodeValidation;
      // return "Please enter 6 digit pincode."
    }
    else if (controlName == 'panNumber' || controlName == 'confirmPANNumber') {
      return this.label.validation.tenDigitPANValidation;
      // return "Please enter 10 digit PAN."
    }
    else if (controlName == 'grossSalary' || controlName == 'netSalary' || controlName == 'annualIncome' || controlName == 'itrIncome') {
      return this.label.validation.fifteenDigitNumericWithTwoDecimalValidation;
      // return "Please enter 15 digit numeric with maximum of 2 decimal values"
    }
    else if (controlName == 'subvention' || controlName == 'additionalSubvention') {

      return this.label.validation.notInRangeFinProduct;
      // return "Not in Range allowed by Financial Product/Special Program"
    }
    else {
      return this.label.validation.maxCharExceedValidation;
      // return "Field has exceeded maximum number of characters."
    }

  }

  getMaxValueMessage(controlName) {

    if(this.borrowerRenderingService.language){
      if(this.borrowerRenderingService.language==="ENGLISH"){
        this.label = new ValidationServiceLabelEN();
      }else if(this.borrowerRenderingService.language==="HINDI"){
        this.label = new ValidationServiceLabelHN();
      }
    }else{
        this.label = new ValidationServiceLabelEN();
    }

    if (controlName == 'subvention' || controlName == 'additionalSubvention') {
      return this.label.validation.notInRangeFinProduct;
      // return "Not in Range allowed by Financial Product/Special Program"
    }
    else {
      return this.label.validation.maxValueExceedValidation;
      // return "Field has exceeded the maximum value"
    }
  }


  getMinValueMessage(controlName) {

    if(this.borrowerRenderingService.language){
      if(this.borrowerRenderingService.language==="ENGLISH"){
        this.label = new ValidationServiceLabelEN();
      }else if(this.borrowerRenderingService.language==="HINDI"){
        this.label = new ValidationServiceLabelHN();
      }
    }else{
        this.label = new ValidationServiceLabelEN();
    }

    if (controlName == 'subvention' || controlName == 'additionalSubvention') {
      return this.label.validation.notInRangeFinProduct;
      // return "Not in Range allowed by Financial Product/Special Program"
    }
    else {
      if (controlName == 'grossSalary') {
        return this.label.validation.minIncome20000;
        // return "Min. Income Rs. 20,000"
      }
      if (controlName == 'annualIncome') {
        return this.label.validation.minIncome250000;
        // return "Min. Income Rs. 2,50,000"
      }
      return this.label.validation.minValueValidation;
      // return "Field is less than minimum value"
    }
   
    
  }


  getPatternErrorMessage(controlName) {

    if(this.borrowerRenderingService.language){
      if(this.borrowerRenderingService.language==="ENGLISH"){
        this.label = new ValidationServiceLabelEN();
      }else if(this.borrowerRenderingService.language==="HINDI"){
        this.label = new ValidationServiceLabelHN();
      }
    }else{
        this.label = new ValidationServiceLabelEN();
    }

    if (controlName == 'primaryMobilePhone' || controlName == 'otherMobilePhone' || controlName == 'phoneNum' || controlName == 'mobilePhone1' || controlName == 'mobilePhone2') {
      return this.label.validation.validPhoneValidation;
      // return "Please enter valid phone number"
    }
    else if (controlName == 'firstName' || controlName == 'middleName' || controlName == 'lastName' || controlName == 'contactPerson' || controlName == 'applicantName' || controlName == 'organisationName' || controlName == 'nameOfNominee' || controlName == 'spouseName' || controlName == 'motherName' || controlName == 'referenceName1' || controlName == 'referenceName2' || controlName == 'maidenName') {
      return this.label.validation.validNameValidation;
      // return "Please enter valid name"
    }
    else if (controlName == 'aadhar') {
      return this.label.validation.validNumericAdharValidation;
      // return "Please enter valid numeric Aadhar"
    }
    else if (controlName == 'primaryEmail' || controlName == 'secondaryEmail') {
      return this.label.validation.validEmailValidation;
      // return "Please enter valid email ID"
    }
    else if (controlName == 'panNumber' || controlName == 'confirmPANNumber') {
      return this.label.validation.validPANValidation;
      // return "Please enter valid PAN"
    }
    else if (controlName == 'designation') {
      return this.label.validation.validDesignationValidation;
      // return "Please enter valid designation"
    }
    else if (controlName == 'currentPinCode' || controlName == 'permanentPinCode') {
      return this.label.validation.validPincodeValidation;
      // return "Please enter valid Pincode"
    }
    else if (controlName == 'grossSalary' || controlName == 'netSalary' || controlName == 'aproxAvgBankBal' || controlName == 'annualIncome' || controlName == 'itrIncome' || controlName == 'downpaymentValue' || controlName == 'downPaymentAmount' || controlName == 'discount') {
      return this.label.validation.validAmountValidation;
      // return "Please enter valid amount"
    }
    else if (controlName == 'otpField1' || controlName == 'otpField2' || controlName == 'otpField3' || controlName == 'otpField4' || controlName == 'otpField5' || controlName == 'otpField6' || controlName == 'subvention' || controlName == 'additionalSubvention') {
      return this.label.validation.numericValidation;
      // return "Please enter Numeric values"
    }
    else if (controlName == 'currentBuildingNo' || controlName == 'permanentBuildingNo') {
      return this.label.validation.noSpecialCharValidation;
      // return "No special characters allowed"
    }
    else if (controlName == 'currentStreetName' || controlName == 'permanentStreetName') {
      return this.label.validation.noSpecialCharValidation;
      // return "No special characters allowed"
    }
    else if (controlName == 'currentArea' || controlName == 'permanentArea') {
      return this.label.validation.noSpecialCharValidation;
      // return "No special characters allowed"
    }
    else if (controlName == 'currentLandmark' || controlName == 'permanentLandmark') {
      return this.label.validation.noSpecialCharValidation;
      // return "No special characters allowed"
    }
    else if (controlName == 'amount') {
      return this.label.validation.numericValidation;
      // return "Please enter Numeric values"
    }
    else if (controlName == 'variant') {
      return this.label.validation.validVariantValidation;
      // return "Please enter vaild Variant"
    }
    else {
      return this.label.validation.patternMismatchValidation;
      // return "Pattern mismatch."
    }

  }

  getMinLengthErrorMessage(controlName) {

    if(this.borrowerRenderingService.language){
      if(this.borrowerRenderingService.language==="ENGLISH"){
        this.label = new ValidationServiceLabelEN();
      }else if(this.borrowerRenderingService.language==="HINDI"){
        this.label = new ValidationServiceLabelHN();
      }
    }else{
        this.label = new ValidationServiceLabelEN();
    }

    if (controlName == 'primaryMobilePhone' || controlName == 'otherMobilePhone' || controlName == 'mobilePhone1' || controlName == 'mobilePhone2') {
      return this.label.validation.tenDigitValidPhoneValidation;
      // return "Please enter a 10 digit phone number"
    }

    if (controlName == 'organisationName') {
      return this.label.validation.min6CharValidation;
      // return "Please enter minimum of 6 characters"
    }
    if (controlName == 'aadhar') {
      return this.label.validation.tweleveDigitAdharValidation;
      // return "Please enter 12 digit Aadhar number"
    }
    if (controlName == 'designation') {
      return this.label.validation.min2CharValidation;
      // return "Please enter minimum of 2 characters"
    }
    else if (controlName == 'currentPinCode' || controlName == 'permanentPinCode') {
      return this.label.validation.sixDigitPinCodeValidation;
      // return "Please enter 6 digit pincode."
    }
    if (controlName == 'panNumber' || controlName == 'confirmPANNumber') {
      return this.label.validation.tenDigitPANValidation;
      // return "Please enter 10 digit PAN"
    }
    else if (controlName == 'contactPerson') {
      return this.label.validation.min4CharValidation;
      // return "Please enter minimum of 4 characters"
    }
    else if (controlName == 'subvention' || controlName == 'additionalSubvention') {
      return this.label.validation.notInRangeFinProduct;
      // return "Not in Range allowed by Financial Product/Special Program"
    }
    else if (controlName == 'officeStreetName' || controlName == 'officeBuildingNo' || controlName == 'permanentBuildingNo' || controlName == 'permanentStreetName' || controlName == 'currentBuildingNo' || controlName == 'currentStreetName') {
      return this.label.validation.min10CharValidation;
      // return "Please enter minimum 10 characters"
    }
    else {
      return this.label.validation.minCharValidation;
      // return "Please enter minimum number of characters."
    }
  }


  // Validate form instance
  // check_dirty true will only emit errors if the field is touched
  // check_dirty false will check all fields independent of
  // being touched or not. Use this as the last check before submitting
  public validateForm(formToValidate: FormGroup, formErrors: any, checkDirty?: boolean) {
    let form = formToValidate;

    for (let field in formErrors) {
      if (field) {
        formErrors[field] = '';
        const control = form.get(field);
        const messages = this.validationMessages(field);
        if (control && !control.valid) {
          if (!checkDirty || (control.dirty || control.touched)) {
            for (const key in control.errors) {
              if (key) {
                formErrors[field] = formErrors[field] || messages[key];
              } else {
                formErrors[field] = formErrors[field] || messages[key](control.errors[key]);
              }
            }
          }
        }
      }
    }
    return formErrors;
  }

  public validateField(formcontrol: FormControl, formErrors: any, controlName: string, checkDirty?: boolean) {
    for (let field in formErrors) {
      if (field) {
        if (formcontrol && controlName == field) {
          formErrors[field] = '';
          const messages = this.validationMessages(field);
          if (!formcontrol.valid) {
            if (!checkDirty || (formcontrol.dirty || formcontrol.touched)) {
              for (const key in formcontrol.errors) {
                if (key) {
                  formErrors[field] = formErrors[field] || messages[key];
                } else {
                  formErrors[field] = formErrors[field] || messages[key](formcontrol.errors[key]);
                }
              }
            }
          }
        }
      }
    }
    return formErrors;
  }
}




